import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login, isAuthenticated } from "../services/authService";
import toast from "react-hot-toast";

const Login = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = isAuthenticated();
    if (user) {
      navigate("/home");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await login({ mobile, password });
      localStorage.setItem("user", JSON.stringify(data));
      toast.success("Login successful!");
      navigate("/home");
    } catch (err) {
      toast.error(err.message || "Login failed");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-950 px-4">
      <div className="bg-gray-900 w-full max-w-sm p-6 rounded-2xl shadow-lg border border-gray-800">
        {/* App Name */}
        <div className="mb-6 text-center">
          <h1 className="text-3xl font-extrabold text-blue-500">R B Caters & Water</h1>
          <p className="text-sm text-gray-400 mt-1">Smart Water Delivery App</p>
        </div>

        {/* Login Heading */}
        <h2 className="text-white text-xl font-semibold mb-4 text-center">
          👋 Welcome Back
        </h2>

        <form onSubmit={handleLogin}>
          <div className="mb-4">
            <label className="text-sm text-gray-400 mb-1 block">Mobile</label>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              className="w-full px-4 py-2 rounded-xl bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              // placeholder="Enter mobile number"
              placeholder="📱 Registered number"
              required
            />
          </div>
          <div className="mb-6">
            <label className="text-sm text-gray-400 mb-1 block">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 rounded-xl bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              // placeholder="Enter password"
              placeholder="🔒●●●●●●●●"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
          >
            Login
          </button>
        </form>
        <p className="text-sm text-gray-400 mt-6 text-center">
          Don’t have an account?{" "}
          <button
            onClick={() => navigate("/register")}
            className="text-blue-900 underline"
          >
            Register here
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login;
